import { Injectable, OnDestroy } from '@angular/core';

import { TakeUntilDestroy } from '../../../common/take-until-destroy.decorator';
import { disuseStore, useStore } from '../../../store.decorator';
import { CallStatusService } from '../../../teams-call';

import { caAnalysisDialogReducer } from './ca-analysis-dialog.reducer';
import { CaAnalysisDialogState } from './ca-analysis-dialog.state';

@Injectable({ providedIn: 'root' })
@TakeUntilDestroy()
export class CaAnalysisDialogService implements OnDestroy {
    state: CaAnalysisDialogState;

    constructor(readonly callStatusService: CallStatusService) {
        useStore(this, 'coaching.caAnalysis', caAnalysisDialogReducer);
    }

    ngOnDestroy(): void {
        disuseStore(this);
    }
}
